/* deferred product page scripts */

(function() {
  'use strict';

  /* bundle gift wrapping state */
  function uncheckGiftWrap() {
    document.querySelectorAll('.cbb-frequently-bought-selector-input').forEach(function(cb) {
      if (cb.getAttribute('aria-label') && cb.getAttribute('aria-label').toLowerCase().indexOf('gift wrapping') !== -1 && cb.checked) {
        cb.checked = false;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  var giftWrapTimer = setInterval(function() {
    if (document.querySelector('.cbb-frequently-bought-selector-input')) {
      clearInterval(giftWrapTimer);
      uncheckGiftWrap();
    }
  }, 300);
  setTimeout(function() { clearInterval(giftWrapTimer); }, 10000);

  /* wholesale cta: not rendered */

  /* --- 3. Wholesale page GA4 tracking (28 Sub 2026) --- */
  if (location.pathname === '/pages/wholesale') {
    try {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ event: 'wholesale_page_view', event_category: 'engagement', page_path: '/pages/wholesale' });
    } catch (e) {}
    var form = document.querySelector('#ws-form form');
    if (form) {
      form.addEventListener('submit', function() {
        try {
          var type = document.getElementById('ws-type');
          var vol = document.getElementById('ws-volume');
          dataLayer.push({
            event: 'wholesale_inquiry_submit',
            event_category: 'lead',
            wholesale_business_type: type ? type.value : '',
            wholesale_volume: vol ? vol.value : ''
          });
        } catch (e) {}
      });
    }
  }

  /* --- 4. Shopify Chat (Inbox) delayed activation --- */
  /* Chat widget loads via content_for_header (can't prevent download).
   * This delays the visual appearance until user has been on page 5s or scrolls.
   * Saves ~256KB from blocking initial TTI calculation. */
  var chatRevealed = false;
  function revealChat() {
    if (chatRevealed) return;
    chatRevealed = true;
    var style = document.getElementById('bcb-chat-delay');
    if (style) style.remove();
  }
  // Reveal after 5 seconds or on first scroll/click
  setTimeout(revealChat, 5000);
  var revealEvents = ['scroll', 'click', 'touchstart'];
  revealEvents.forEach(function(evt) {
    window.addEventListener(evt, revealChat, { once: true, passive: true });
  });
})();
